import clsx from "clsx";
import React from "react";
import page from "./page.module.scss";

export const enum PageSectionVariant
{
    Hero,
}

export interface PageSectionProps extends React.ComponentProps<"section"> 
{
    variant?: PageSectionVariant;
}

export const PageSection = ({ className, variant, ...props }: PageSectionProps): React.ReactComponentElement<"section", PageSectionProps> =>
{
    const classNames = clsx(
        page.section,
        {
            "hero": variant === PageSectionVariant.Hero,
        },
        className
    );

    return <section {...props} className={classNames} />;
}